module.exports = __webpack_public_path__ + "static/media/elicit-demo.fd3f82bb.gif";